<template>
    <div v-cloak v-if="auth">
        <div class="row mb-3">
            <div class="col-12">
                <div class="row form-group">
                    <div class="col-12"><label for="mailing-search">{{ $lang('Tytuł mailingu:') }}</label></div>
                    <div class="col-8 col-md-10">
                        <input
                            class="form-control d-inline-block w-100 w-md-auto mr-3"
                            id="mailing-search"
                            type="text"
                            v-model="search"
                            @keydown="searchInputKeyDown"
                            :placeholder="$lang('Wyszukaj mailing') + '...'"
                        >
                    </div>
                    <div class="col-4 col-md-2 form-group">
                        <button class="btn btn-primary btn-block text-nowrap" @click.prevent="searchButtonClick">
                            <span>{{ $lang('Szukaj') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>
        <div class="simple-table structure-table" v-if="historyList.length">
            <table class="table table-striped table-sm table-hover mb-0">
                <table-headers :headers="tableHeaders"></table-headers>
                <tbody>
                <tr v-for="(history, index) in historyList">
                    <td :data-title="$lang('Lp.')">
                        {{ pagination.from + index }}
                    </td>
                    <td :data-title="$lang('Tytuł')">
                        <span href="">{{ history.draft.title }}</span>
                    </td>
                    <td :data-title="$lang('Data wysyłki')">
                        <span href="">{{ parseDateTime(history.send_date) }}</span>
                    </td>
                    <td :data-title="$lang('Status wysyłki')">
                        <span href="" v-if="history.status === 'sent'">{{ $lang("Wysłano") }}</span>
                        <span href="" v-if="history.status === 'canceled'">{{ $lang("Anulowano") }}</span>
                        <span href="" v-if="history.status === 'pending'">{{ $lang("Oczekujący") }}</span>
                    </td>
                    <td :data-title="$lang('Akcje')">
                        <a
                            href="#"
                            @click.prevent="showModal('PREVIEW', index)"
                            class="mx-1"
                            :title="$lang('Podgląd')  + ': ' +  history.draft.title"
                            :aria-label="$lang('Podgląd') + ': ' +  history.draft.title"
                        >
                            {{ $lang('Podgląd') }}
                        </a>
                        <a
                            href="#"
                            v-if="history.status === 'pending'"
                            @click.prevent="showModal('CANCEL', history.id)"
                            class="mx-1"
                            :title="$lang('Anuluj wysyłkę')  + ': ' +  history.draft.title"
                            :aria-label="$lang('Anuluj wysyłkę') + ': ' +  history.draft.title"
                        >
                            {{ $lang('Anuluj wysyłkę') }}
                        </a>
                        <a
                            href="#"
                            @click.prevent="showModal('RESEND', history.draft.id)"
                            class="mx-1"
                            :title="$lang('Wyślij ponownie')  + ': ' +  history.draft.title"
                            :aria-label="$lang('Wyślij ponownie') + ': ' +  history.draft.title"
                        >
                            {{ $lang('Wyślij ponownie') }}
                        </a>
                        <a
                            href="#"
                            v-if="history.status === 'sent'"
                            @click.prevent="showModal('STATISTICS', history.id)"
                            class="mx-1"
                            :title="$lang('Statystyki')  + ': ' +  history.draft.title"
                            :aria-label="$lang('Statystyki') + ': ' +  history.draft.title"
                        >
                            {{ $lang('Statystyki') }}
                        </a>
                        <a
                            :href="editUrl(history.id)"
                            v-if="history.status === 'sent'"
                            class="mx-1"
                            :title="$lang('Więcej')  + ': ' +  history.draft.title"
                            :aria-label="$lang('Więcej') + ': ' +  history.draft.title"
                        >
                            {{ $lang('Więcej') }}
                        </a>
                        <i
                            v-if="history.draft.attachments.length > 3"
                            :title="$lang('Mailing zawiera załącznik')"
                            aria-hidden="true"
                            class="fa fa-paperclip pull-right"
                        ></i>
                    </td>

                    <div class="modal" :id="'cancel-modal-' + history.id" tabindex="-1" role="dialog"
                         :aria-labelledby="'cancel-modal-' + history.id + '-label'" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" :id="'cancel-modal-' + history.id + '-label'">
                                        {{ $lang('Anulowanie mailingu') }}
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal"
                                            :aria-label="$lang('Zamknij')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    {{ $lang('Czy na pewno chcesz anulować mailing "') }}
                                    <strong>{{ history.draft.title }}</strong>" ?
                                </div>
                                <div class="modal-footer">
                                    <a href="#" class="btn btn-default" data-dismiss="modal">{{ $lang('Nie') }}</a>
                                    <a href="#" class="btn btn-primary" @click.prevent="cancelMailing(history.id)"
                                       data-dismiss="modal">{{ $lang('Tak') }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else>
            {{ $lang('Brak wyników') }}
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>

        <div v-if="historyList.length && historyElement !== null" class="modal fade" :id="'preview-modal'" tabindex="-1">
            <div class="modal-dialog modal-lg modal-email">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Podgląd') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-html="historyList[historyElement].content"></div>
                        <div class="col-12" v-if="historyList[historyElement].draft.attachments.length > 3">
                            <strong>
                                <i aria-hidden="true" class="fa fa-paperclip mr-1"> {{ $lang("Załączniki") }}:</i>
                            </strong>
                            <ul>
                                <li v-for="(filename) in getAttachments(historyList[historyElement].draft.attachments)">
                                    {{ filename }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal" id="close">
                            {{ $lang('Zamknij') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="statistics.length !== 0" class="modal" id="statistics-modal" tabindex="-1" role="dialog"
             aria-labelledby="statistics-modal-label" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="statistics-modal-label">
                            {{ $lang('Statystyki') }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal"
                                :aria-label="$lang('Zamknij')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-12 float-left">
                            <dt class="col-4 float-left">
                                {{ $lang('Maile wysłane') }}:
                            </dt>
                            <dd class="col-8 float-left">
                                {{ statistics['allSent'] }}
                            </dd>
                        </div>
                        <div class="col-12 float-left">
                            <dt class="col-4 float-left">
                                {{ $lang('Maile wyświetlone') }}:
                            </dt>
                            <dd class="col-8 float-left">
                                {{ statistics['read'] }}
                            </dd>
                        </div>
                        <div class="col-12 float-left">
                            <dt class="col-4 float-left">
                                {{ $lang('Nieprawidłowe adresy') }}:
                            </dt>
                            <dd class="col-8 float-left">
                                {{ statistics['invalid'] }}
                            </dd>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-default" data-dismiss="modal">{{ $lang('Zamknij') }}</a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="historyList.length && historyDraft !== null" class="modal" id="resend-modal" tabindex="-1" role="dialog"
             aria-labelledby="resend-modal-label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg modal-email" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="resend-modal-label">
                            {{ $lang('Ponowna wysyłka mailingu') }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal"
                                :aria-label="$lang('Zamknij')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pb-2">
                        <new-mail
                            :send_route="send_route"
                            :test_route="test_route"
                            :recipients_route="recipients_route"
                            :draft="historyDraft"
                            :upload_image_route="upload_image_route"
                            :upload_attachment_route="upload_attachment_route"
                            :delete_attachment_route="delete_attachment_route"
                            :upload_html_content_file_route="upload_html_content_file_route"
                            :delete_html_content_file_route="delete_html_content_file_route"
                            :modules="modules"
                            :roles="roles"
                            :templates="templates"
                            :libraries="libraries"
                            :modal_mode="true"
                            :default_footer="default_footer"
                            :key="historyDraft.id"
                            :library_type_options="library_type_options"
                            :project="project"
                        >
                        </new-mail>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-default" data-dismiss="modal">{{ $lang('Zamknij') }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import axios from 'axios';
import Notification from '../../../mixins/show-notification';
import {EventBus} from "../../../mixins/event-bus";
import TableHeaders from '../../table/table-headers';
import PaginationComponent from '../../pagination-component';

export default {

    name: 'mailing-history-table',

    components: {
        TableHeaders,
        PaginationComponent,
        EventBus
    },

    mixins: [Notification],

    props: {
        auth: {
            type: Boolean,
            required: true
        },
        list_route: {
            type: String,
        },
        history_route: {
            type: String,
        },
        cancel_route: {
            type: String,
        },
        resend_route: {
            type: String,
        },
        send_route: {
            type: String,
        },
        recipients_route: {
            type: String,
        },
        test_route: {
            type: String,
        },
        upload_image_route: {
            type: String,
        },
        upload_attachment_route: {
            type: String,
        },
        delete_attachment_route: {
            type: String,
        },
        upload_html_content_file_route: {
            type: String,
        },
        delete_html_content_file_route: {
            type: String,
        },
        templates: {
            type: Array,
            default: () => [],
        },
        libraries: {
            type: Array,
            default: () => [],
        },
        modules: {
            type: Array,
            default: () => [],
        },
        roles: {
            type: Array,
            default: () => [],
        },
        default_footer: {
            type: Object
        },
        library_type_options: {
            type: Object|Array
        },
        project: {
            type: String
        }
    },

    data() {
        return {
            historyList: [],
            pagination: [],
            statistics: [],
            perPage: 10,
            sortColumn: 'send_date',
            sortOrder: 'desc',
            search: '',
            tableHeaders: [
                {title: this.$lang('Lp.')},
                {title: this.$lang('Tytuł'), column: 'title', sort: 'alpha'},
                {title: this.$lang('Data wysyłki'), column: 'send_date', sort: 'numeric'},
                {title: this.$lang('Status wysyłki')},
                {title: this.$lang('Akcje')}
            ],
            historyElement: null,
            historyDraft: null,
        };
    },
    created() {
        this.setEventBusListeners();
        this.requestHistory();
    },

    watch: {
        sortColumn() {
            this.requestHistory();
        }
    },

    methods: {
        editUrl(id) {
            return this.history_route + '/details' + '/' + id;
        },

        requestHistory(filters) {
            const params = {
                ...filters,
                perPage: this.perPage,
                search: this.search,
                sortColumn: this.sortColumn,
                sortOrder: this.sortOrder
            };

            return axios.get(this.list_route, {params}).then((response) => {
                this.historyList = response.data.history.data;
                this.pagination = response.data.history;
            }).catch((error) => {
                const message = (error.response.data ? error.response.data : error.response.statusText);
                this.showNotification('error', message);
            });
        },

        cancelMailing(id) {
            const params = {
                id: id
            };
            return axios.post(this.cancel_route, params).then((response) => {
                if (response.data.cancel) {
                    this.requestHistory();
                    this.showNotification('success', 'Mailing został anulowany');
                }
            }).catch((error) => {
                const message = (error.response.data ? error.response.data : error.response.statusText);
                this.showNotification('error', message);
            });
        },

        searchInputKeyDown(event) {
            if (event.keyCode === 13) {
                this.requestHistory();
            }
        },

        searchButtonClick() {
            this.requestHistory();
        },

        setEventBusListeners() {
            EventBus.$on('changePage', ({value}) => {
                this.requestHistory({page: value});
            });

            EventBus.$on('sortByColumn', ({column, order}) => {
                this.sortColumn = column;
                this.sortOrder = order;
                this.requestHistory({page: this.pagination.current_page});
            });
            EventBus.$on('newMailingHistory', (payload) => {
                this.requestHistory();
            });
        },

        showModal(type, id) {
            if (type === 'PREVIEW') {
                this.$set(this, 'historyElement', id);
                this.$nextTick(() => {
                    $("#preview-modal").modal("show");
                });
            }

            if (type === 'RESEND') {
                axios.post('history/draft/' + id, {}).then((response) => {
                    this.$set(this, 'historyDraft', response.data);
                    this.$nextTick(() => {
                        $("#resend-modal").modal("show");
                    });
                }).catch((error) => {
                    const message = (error.response.data ? error.response.data : error.response.statusText);
                    this.showNotification('error', message);
                });
            }
            if (type === 'STATISTICS') {
                axios.post('history/statistics/' + id, {}).then((response) => {
                    this.$set(this, 'statistics', response.data);
                    this.$nextTick(() => {
                        $("#statistics-modal").modal("show");
                    });
                }).catch((error) => {
                    const message = (error.response.data ? error.response.data : error.response.statusText);
                    this.showNotification('error', message);
                });
            }

            if (type === 'CANCEL') {
                $("#cancel-modal-" + id).modal("show");
            }
        },
        parseDateTime(datetime) {
            let date = new Date(datetime);
            return ("0" + date.getDate()).slice(-2) + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear() + ' ' + date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        getAttachments(history) {
            if (history.length > 3) {
                history = JSON.parse(history);
                history = history.map(attachment => attachment.filename);
            }

            return history;
        },
    },

}

</script>
